@if (isLoading) {
  <app-tdo-progress-spinner data-cy="report-viewer-dialog-spinner"></app-tdo-progress-spinner>
}
@if (!isLoading) {
  <div class="section" style="flex: 1; display: flex; flex-direction: column; height: 800px" data-cy="report-viewer-dialog-container">
    <div class="section-content" style="display: flex; flex-direction: column; flex: 1; height: 100%" data-cy="report-viewer-dialog-content">
      <div style="display: flex; align-items: flex-start;" data-cy="report-viewer-dialog-main">
        @if (!isSpecificReport) {
          <div style="flex-basis: 430px;padding: 10px 10px 10px 5px; overflow-y: scroll" data-cy="report-viewer-dialog-sidebar">
            @if (blShowReportsByCategory && isReportViewer) {
              <div style="padding-top: 10px; margin-bottom: 20px" data-cy="report-viewer-dialog-category-container">
                <div style="height: 30px; position: relative; top: -18px;" data-cy="report-viewer-dialog-category-dropdown-container">
                  <app-tdo-dropdown placeholder="Select Category"
                    appearance="legacy"
                    [dataSource]="reportCategoryEnumItems"
                    [isObjectValue]="true"
                    dataSourceDisplayKey="ItemDisplayValue"
                    [value]="selectedEnumReportCategory"
                    (selectionChange)="onUserReportCategoryChange($event)"
                    data-cy="report-viewer-dialog-category-dropdown">
                  </app-tdo-dropdown>
                </div>
              </div>
            }
            @if (blReportByCategorySelected) {
              <div style="flex: 1; height: 30px;" data-cy="report-viewer-dialog-report-select-container">
                <mat-form-field floatLabel="auto"
                  style="width: 100%; background-color: white; border-radius: 8px; height: 30px;"
                  data-cy="report-viewer-dialog-report-form-field">
                  <mat-label data-cy="report-viewer-dialog-report-label">Select Report</mat-label>
                  <mat-select #reports data-cy="report-viewer-dialog-report-select">
                    @for (report of reportsByCategory; track trackByReportId($index, report)) {
                      <mat-option (onSelectionChange)="onReportSelected(report,$event);"
                        [value]="report"
                        [attr.data-cy]="'report-viewer-dialog-report-option-' + transformReportName(report.ReportName)">
                        {{report.ReportName}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
            @if (showAgingFilters || showFinancialSummaryFilters || showFinancialSnapshotFilters || showFrontDeskFilters) {
              <div
                style="width: 100%; height: 70%; overflow-x: scroll"
                data-cy="report-viewer-dialog-filters-container">
                <div
                  style="padding: 10px 10px 0px 0px; margin-bottom: 0px; margin-top: 20px; border-bottom: 2px solid var(--tdo-blue) "
                  data-cy="report-viewer-dialog-parameters-header">
                  <h5 data-cy="report-viewer-dialog-parameters-title">Report Parameters</h5>
                </div>
                @if (showAgingFilters) {
                  <app-report-aging-filter [showParametersForReport]="showParametersForReport"
                    [isGeneric]="isGeneric" (newItemEvent)="addItem($event)"
                    (onChecked)="childOnChecked($event)"
                    style="overflow-y: scroll; overflow-x: scroll"
                  data-cy="report-viewer-dialog-aging-filter"></app-report-aging-filter>
                }
                @if (showFinancialSummaryFilters) {
                  <app-report-financial-summary-filter
                    (newItemEvent)="addItemFinancial($event)"
                  data-cy="report-viewer-dialog-financial-summary-filter"></app-report-financial-summary-filter>
                }
                @if (showFinancialSnapshotFilters) {
                  <app-report-financial-snapshot-filters
                    [isSnapShotReport]="isSnapShotReport"
                    [isDailySnapShot]="isDailySnapShot"
                    (newItemEvent)="addItemFinancialSnapshot($event)"
                    (onChecked)="childOnChecked($event)"
                  data-cy="report-viewer-dialog-financial-snapshot-filter"></app-report-financial-snapshot-filters>
                }
                @if (showFrontDeskFilters) {
                  <app-report-front-desk-filters [isEnvelop]="isEnvelop"
                    [isTreatmentPlan]="isTreatmentPlan"
                    (newItemEvent)="addItemFrontDesk($event)"
                  data-cy="report-viewer-dialog-front-desk-filter"></app-report-front-desk-filters>
                }
              </div>
            }
            @if (activeReport) {
              <div style="position:fixed;bottom: 0; display: inline-flex; flex-direction: column; padding-bottom: 5px" data-cy="report-viewer-dialog-actions">
                <button mat-button class="tdo-button tdo-save" (click)="runReport()" data-cy="report-viewer-dialog-run-button">Run Report</button>
              </div>
            }
          </div>
        }
        @if (!isSpecificReport && !isSnapshotDevExpress && !showReportsToBeCompletedFilters) {
          <div class="noSpecificReport" data-cy="report-viewer-dialog-report-display">
            @if (!isSnapShotReport && !isEmptyReport) {
              <dx-report-viewer [reportUrl]="reportUrl" [height]="'100%'"
                [width]="'100%'" data-cy="report-viewer-dialog-dx-viewer">
                <dxrv-request-options [invokeAction]="invokeAction" [host]="hostUrlDXXRDV" data-cy="report-viewer-dialog-dx-options"></dxrv-request-options>
                <dxrv-callbacks (BeforeRender)="BeforeRender($event)" data-cy="report-viewer-dialog-dx-callbacks"></dxrv-callbacks>
                <dxrv-remote-settings [authToken]="authToken" data-cy="report-viewer-dialog-dx-remote"></dxrv-remote-settings>
              </dx-report-viewer>
            }
            @if (!isSnapShotReport && isEmptyReport) {
              <dx-report-viewer [reportUrl]="emptyReportUrl" [height]="'100%'"
                [width]="'100%'" data-cy="report-viewer-dialog-dx-empty-viewer">
                <dxrv-request-options [invokeAction]="invokeAction" [host]="hostUrlDXXRDV" data-cy="report-viewer-dialog-dx-empty-options"></dxrv-request-options>
                <dxrv-callbacks (BeforeRender)="BeforeRender($event)" data-cy="report-viewer-dialog-dx-empty-callbacks"></dxrv-callbacks>
                <dxrv-remote-settings [authToken]="authToken" data-cy="report-viewer-dialog-dx-empty-remote"></dxrv-remote-settings>
              </dx-report-viewer>
            }
            @if (isSnapShotReport) {
              <app-report-financial-snapshot
              style="height:100%; width:100%;" data-cy="report-viewer-dialog-snapshot"></app-report-financial-snapshot>
            }
          </div>
        }
        @if (!isSpecificReport && showReportsToBeCompletedFilters) {
          <div class="noSpecificReport" data-cy="report-viewer-dialog-reports-to-be-completed-container">
            @if (showReportsToBeCompletedFilters) {
              <app-report-reports-to-be-completed
              style="height:100%; width:75%;" data-cy="report-viewer-dialog-reports-to-be-completed"></app-report-reports-to-be-completed>
            }
          </div>
        }
        @if (isSpecificReport) {
          <div class="SpecificReport" data-cy="report-viewer-dialog-specific-report">
            @if (!isSnapShotReport) {
              <dx-report-viewer [reportUrl]="reportUrl" [height]="'100%'" [width]="'100%'" data-cy="report-viewer-dialog-specific-dx-viewer">
                <dxrv-request-options [invokeAction]="invokeAction" [host]="hostUrlDXXRDV" data-cy="report-viewer-dialog-specific-dx-options"></dxrv-request-options>
                <dxrv-callbacks (BeforeRender)="BeforeRender($event)" data-cy="report-viewer-dialog-specific-dx-callbacks"></dxrv-callbacks>
                <dxrv-remote-settings [authToken]="authToken" data-cy="report-viewer-dialog-specific-dx-remote"></dxrv-remote-settings>
              </dx-report-viewer>
            }
            @if (isSnapShotReport) {
              <app-report-financial-snapshot
              style="height:100%; width:75%;" data-cy="report-viewer-dialog-specific-snapshot"></app-report-financial-snapshot>
            }
          </div>
        }
        @if (!isSpecificReport && isSnapshotDevExpress) {
          <div class="noSpecificReport" data-cy="report-viewer-dialog-snapshot-devexpress">
            @if (isSnapShotReport && !isEmptyReport) {
              <dx-report-viewer [reportUrl]="reportUrl" [height]="'100%'"
                [width]="'100%'" data-cy="report-viewer-dialog-snapshot-dx-viewer">
                <dxrv-request-options [invokeAction]="invokeAction" [host]="hostUrlDXXRDV" data-cy="report-viewer-dialog-snapshot-dx-options"></dxrv-request-options>
                <dxrv-callbacks (BeforeRender)="BeforeRender($event)" data-cy="report-viewer-dialog-snapshot-dx-callbacks"></dxrv-callbacks>
                <dxrv-remote-settings [authToken]="authToken" data-cy="report-viewer-dialog-snapshot-dx-remote"></dxrv-remote-settings>
              </dx-report-viewer>
            }
            @if (isSnapShotReport && isEmptyReport) {
              <dx-report-viewer [reportUrl]="emptyReportUrl" [height]="'100%'"
                [width]="'100%'" data-cy="report-viewer-dialog-snapshot-empty-dx-viewer">
                <dxrv-request-options [invokeAction]="invokeAction" [host]="hostUrlDXXRDV" data-cy="report-viewer-dialog-snapshot-empty-dx-options"></dxrv-request-options>
                <dxrv-callbacks (BeforeRender)="BeforeRender($event)" data-cy="report-viewer-dialog-snapshot-empty-dx-callbacks"></dxrv-callbacks>
                <dxrv-remote-settings [authToken]="authToken" data-cy="report-viewer-dialog-snapshot-empty-dx-remote"></dxrv-remote-settings>
              </dx-report-viewer>
            }
          </div>
        }
      </div>
    </div>
  </div>
}


